import { createContext, useContext } from 'react';

type TaxChartContextValue = {
  companyId: number;
  // Off for offscreen/export renders.
  canOverride: boolean;
};

const TaxChartContext = createContext<TaxChartContextValue | null>(null);

export const TaxChartContextProvider = TaxChartContext.Provider;

// Null outside a TaxDiagram — the node is reused in OrgDiagram, so this doesn't throw.
export function useTaxChartContext(): TaxChartContextValue | null {
  return useContext(TaxChartContext);
}
